<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1213.21 1032.33"
    class="svg-icon"
  >
    <path
      class="cls-1"
      d="M917,99.84c26,0,52.93,5.58,82.41,17.07C1061.67,141.25,1108,183.47,1133.44,239c26.24,57.35,29.48,126.46,9.38,199.88-18.89,67.46-50.69,129-97.22,188.29-40.27,51.27-92.66,101.85-160.17,154.6l-.15.12-.14.11c-57,45-117.47,88-175.95,129.66-27.51,19.58-55.9,39.78-83.92,60.18-26.55-19.1-53.38-37.92-79.48-56.23-61.95-43.45-126-88.37-184.54-135.91-63.81-51.83-115-102-156.46-153.38l0-.05,0,0c-71.92-88.79-107.91-177.64-110-271.59A283.17,283.17,0,0,1,104.33,273a231.68,231.68,0,0,1,30.28-66.87,217.79,217.79,0,0,1,48.67-52A243.5,243.5,0,0,1,250.66,118l.66-.23.66-.25a235,235,0,0,1,82.67-15c76.16,0,148.14,36.6,192.55,97.88,9,12.41,18.26,24,29,37.33,2.3,2.87,4.7,5.85,7.2,9l57,71.27,59.76-69c47-54.18,89.74-92.45,130.83-117,36.24-21.66,70.9-32.18,106-32.18h0m0-76c-97.63,0-190.77,56-294.22,175.42-13.77-17.22-24.34-30.08-34-43.39C528.68,72.94,433.05,26.55,334.65,26.55a311.36,311.36,0,0,0-109.33,19.8C93.53,93,15.47,210.05,18.69,356.3c2.75,121.68,52.57,225.92,127,317.76,124.9,154.74,294.11,256.68,451.83,371.47,10.31,7.63,19.23,10.63,27.43,10.63,14.28,0,26.35-9.12,39.62-18.89,89.31-65.2,180.46-126.74,267.7-195.61,129.26-101,237.86-218.35,283.78-382.28,51-185.5-23.88-348.74-189-413.26C989.26,31.38,952.81,23.83,917,23.84Z"
      transform="translate(-18.59 -23.84)"
    />
  </svg>
</template>

<script>
export default {
  name: "IconHeartEmpty"
};
</script>
